/* eslint-disable no-console */

/**
 * Wrapper for console logging methods that enforces strict typing and consistent logging interface.
 * Prevents direct console.log usage across codebase and centralizes logging configuration.
 * Makes it easier to modify logging behavior (e.g. add timestamps, switch to external logger).
 */
const logger = {
  /**
   * Outputs a debugging message to the console.
   * @param message - A message to write to the console.
   * @param optionalParams - Additional arguments to output.
   */
  debug: (message: unknown, ...optionalParams: unknown[]) =>
    import.meta.env.VITE_SHOW_DEBUG === "true"
      ? console.debug(message, ...optionalParams)
      : undefined,

  /**
   * Outputs an informational message to the console.
   * @param message - A message to write to the console.
   * @param optionalParams - Additional arguments to output.
   */
  info: (message: unknown, ...optionalParams: unknown[]) =>
    console.info(message, ...optionalParams),

  /**
   * Outputs a warning message to the console.
   * @param message - A message to write to the console.
   * @param optionalParams - Additional arguments to output.
   */
  warn: (message: unknown, ...optionalParams: unknown[]) =>
    console.warn(message, ...optionalParams),

  /**
   * Outputs an error message to the console.
   * @param message - A message to write to the console.
   * @param optionalParams - Additional arguments to output.
   */
  error: (message: unknown, ...optionalParams: unknown[]) =>
    console.error(message, ...optionalParams),
}

export default logger
